module.exports = __webpack_public_path__ + "img/block-6.d4efec82.svg";